import { func, bool } from 'prop-types'
import { Component } from 'react'
import {
  getAllChildNodes,
  getCheckedStateByChildren,
} from '../FileBrowserView/utils'
import RawFilterBar from './unmanaged'
import { flatten } from './utils'

export { RawFilterBar }

export default class FilterBar extends Component {
  static propTypes = {
    ...RawFilterBar.propTypes,
    focused: bool,
    onChange: func,
  }

  constructor(props) {
    super(props)

    this.state = {
      value: props.value || [],
      fileValues: props.fileValues || {},
      lastPath: [],
    }

    this.blur = this.blur.bind(this)
    this.focus = this.focus.bind(this)
    this.onFileToggle = this.onFileToggle.bind(this)
    this.pathChange = this.pathChange.bind(this)
    this.valueFor = this.valueFor.bind(this)
  }

  valueFor(file) {
    return this.state.fileValues[file.id]
  }

  valuePayload(file) {
    if (file.payload) {
      if (file.payload.object) {
        if (typeof file.payload.object === 'string') {
          return file.payload
        }
        return {
          ...file.payload,
          object: {
            ...file.payload.object,
            value: this.valueFor(file),
          },
        }
      }
      return {
        ...file.payload,
        object: {
          value: this.valueFor(file),
        },
      }
    }
    return {}
  }

  get value() {
    const { value } = this.state
    const { fileTree } = this.props
    const flatTree = fileTree.flattened || flatten(fileTree)

    return value
      .map((fileID) => flatTree.find((node) => node.id === fileID))
      .filter((filter) => filter)
      .map((filter) => ({
        ...filter,
        payload: this.valuePayload(filter),
      }))
  }

  get metaValue() {
    const { value } = this.state

    return {
      value: {
        selected: value || [],
      },
    }
  }

  changed() {
    if (this.props.onChange) {
      this.props.onChange(this.value, this.metaValue)
    }
  }

  pathChange(newPath) {
    this.setState((prevState) => ({
      lastPath: prevState.currentPath || [],
      currentPath: newPath,
    }))

    if (this.props.onPathChange) {
      this.props.onPathChange(newPath)
    }
  }

  onFileToggle(file) {
    if (this.state.value.includes(file.id)) {
      this.onFileUnselect(file)
    } else {
      this.onFileSelect(file)
    }
  }

  collectFiles(parentFile) {
    const children = getAllChildNodes(parentFile)
    const parents = Object.assign([], parentFile.path.slice(1)).reverse()
    const files = [parentFile.id, ...children]
    const nextValue = [...this.state.value, parentFile.id]

    for (let i = 0; i < parents.length; i += 1) {
      const checkedState = getCheckedStateByChildren(parents[i], nextValue)
      if (checkedState === 'all') {
        files.push(parents[i].id)
      } else {
        break
      }
    }

    return files.filter((f) => !this.state.value.includes(f))
  }

  onFileSelect(file) {
    const filesToAdd = this.collectFiles(file)

    this.setState(
      (lastState) => ({
        value: [...lastState.value, ...filesToAdd],
      }),
      this.changed
    )
  }

  onFileUnselect(file) {
    this.setState((lastState) => {
      const children = getAllChildNodes(file)
      const parentIDs = file.path.reduce((arr, f) => arr.concat(f.id), [])
      const filesToRemove = [file.id, ...children, ...parentIDs]
      const value = lastState.value.filter(
        (v) => filesToRemove.find((f) => v === f) === undefined
      )

      return {
        value,
      }
    }, this.changed)
  }

  focus() {
    this.setState({
      focused: true,
    })
  }

  blur() {
    this.setState({
      focused: false,
    })
  }

  render() {
    return (
      <RawFilterBar
        {...this.props}
        {...this.state}
        focused={this.props.focused || this.state.focused}
        onBlur={this.blur}
        onFocus={this.focus}
        onPathChange={this.pathChange}
        onFileToggle={this.onFileToggle}
      />
    )
  }
}
